import { AudioInputTest, testAudioInputDevice, testVideoInputDevice, testAudioOutputDevice, VideoInputTest, AudioOutputTest, testMediaConnectionBitrate } from "@twilio/rtc-diagnostics";
import * as Tools from "../../../../helpers/Tools";
import { Logger } from '../utils';

let identity = null;
let roomId = null;

const getDiagnosticsReport = (report, testName) => {
    return { identity: identity, roomId: roomId, testName, report };
}

const audioInTest = (report) => {
    console.log(report);
    Logger("UI.Twilio.Room.RTCDiagnostics.AudioInputTest", new Date(), getDiagnosticsReport(report, "AudioInputTest"));
};

const audioOutTest = (report) => {
    console.log(report);
    Logger("UI.Twilio.Room.RTCDiagnostics.AudioOutputTest", new Date(), getDiagnosticsReport(report, "AudioOutputTest"));
};

const videoTest = (report) => {
    console.log(report);
    Logger("UI.Twilio.Room.RTCDiagnostics.VideoInputTest", new Date(), getDiagnosticsReport(report, "VideoInputTest"));
};

const mediaConnectionTest = (report) => {
    console.log(report);
    Logger("UI.Twilio.Room.RTCDiagnostics.MediaConnectionBitrateTest", new Date(), getDiagnosticsReport(report, "MediaConnectionBitrateTest"));
}

export const logRTCDiagnostics = (twilioDiagnosticsSettings, roomName, roomIdentity, callbackOnComplete) => {
    const { enableRTCDiagnostics } = window.serverData.data;
    const { rtcTestDurationInSeconds = 8, enableInputAudioTest = false, enableInputVideoTest = false, enableOutputAudioTest = false, enableBandwidthRequirementsTest = false } = twilioDiagnosticsSettings || {};
    if (!enableRTCDiagnostics || !roomName || !twilioDiagnosticsSettings || (!enableInputAudioTest && !enableOutputAudioTest && !enableBandwidthRequirementsTest && !enableInputVideoTest)) {
        if (callbackOnComplete)
            callbackOnComplete();
        return;
    }
    identity = roomIdentity;
    roomId = roomName;
    let audioInputTest, videoInputTest, audioOutputTest, mediaConnectionBitrateTest = null;
    if (enableInputAudioTest) 
        audioInputTest = testAudioInputDevice({ debug: false, enableRecording: false });      
    if (enableInputVideoTest)
        videoInputTest = testVideoInputDevice();
    if (enableOutputAudioTest)
        audioOutputTest = testAudioOutputDevice({ doLoop: false });

    if (enableBandwidthRequirementsTest) {
        const url = Tools.buildUrl(window.serverData.data.portalAPIURL, `/api/v2/video/NTSToken?roomid=${roomName}`);
        const params = {
            headers: {
                "accept": "application/json",
                "content-type": "application/json"
            },
            method: "GET"
        };
        Logger("UI.Twilio.Room.FetchNTSToken.Start", new Date());
        fetch(url, params)
            .then(resp => {
                return resp.json();
            })
            .then(resp => {
                const { iceServers = [] } = resp || {};
                if (iceServers.length > 0) {
                    Logger("UI.Twilio.Room.FetchNTSToken.Success", new Date(), resp);
                    mediaConnectionBitrateTest = testMediaConnectionBitrate({
                        iceServers
                    });
                    mediaConnectionBitrateTest.on("end", mediaConnectionTest);
                }
                else
                    Logger("UI.Twilio.Room.FetchNTSToken.Failure", new Date(), { "error": "No ice servers found." });

            }).catch(err => {
                mediaConnectionBitrateTest = null;
                Logger("UI.Twilio.Room.FetchNTSToken.Failure", new Date(), JSON.stringify(err));
            });
    }
    if (audioInputTest)
        audioInputTest.on(AudioInputTest.Events.End, audioInTest);
    if (audioOutputTest)
        audioOutputTest.on(AudioOutputTest.Events.End, audioOutTest);
    if (videoInputTest)
        videoInputTest.on(VideoInputTest.Events.End, videoTest);

    setTimeout(() => {       
        if (audioInputTest && audioInputTest.stop)
            audioInputTest.stop();
        if (videoInputTest && videoInputTest.stop)
            videoInputTest.stop();
        if (audioOutputTest && audioOutputTest.stop)
            audioOutputTest.stop();
        if (mediaConnectionBitrateTest && mediaConnectionBitrateTest.stop)
            mediaConnectionBitrateTest.stop();
        if (callbackOnComplete)
            callbackOnComplete();
    }, rtcTestDurationInSeconds * 1000);
};
    